export function hideProps(...attrs) {
    return attrs.reduce((acc, n) => ({
        ...acc,
        [n]: {
            table: {
                disable: true,
            },
        },
    }), {});
}
export function hideControls(...attrs) {
    return attrs.reduce((acc, n) => ({
        ...acc,
        [n]: {
            control: false,
        },
    }), {});
}
export const sleep = (ms = 3000) => new Promise((resolve) => setTimeout(resolve, ms));
